import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConstant } from '@app/shared/constants';
import { environment } from '@env/environment';
import {GetProfileInfoInterface} from '@app/shared/services/address/getProfileInfo.interface';
import {APIResponse} from '@app/shared/services/core/ICore.interface';
import {GetAllAddressInteface} from '@app/shared/services/address/getAllAddress.inteface';
@Injectable({
  providedIn: 'root'
})
export class AddressService {

  constructor(private http: HttpClient) { }

  getCountries() {
    return this.http.get<any>(environment.baseUrl + AppConstant.COUNTRY_LIST);
  }

  getStatesByCountry(countryId: string) {
    return this.http.get<any>(environment.baseUrl + AppConstant.STATE_BYCOUNTRY_GET + countryId);
  }

  getStoreAdminById(storeAdminId: number) {
    return this.http.get<GetProfileInfoInterface>(environment.baseUrl + AppConstant.Profile_GET + storeAdminId);
  }

  updateStoreAdminProfile(storeadminDetail: any) {

    return this.http.post(environment.baseUrl + AppConstant.Profile_SAVE, storeadminDetail);
  }

  /** Function to add address
   *@param AddresModel model
   */
  addAddress(form: any) {
    return this.http.post(environment.baseUrl + AppConstant.AddAddress, form);
  }

  /** Function to update address
 *@param AddresModel model
 */
  updateAddress(form: any) {
    return this.http.post(environment.baseUrl + AppConstant.UpdateAddress, form);
  }

  /** Function to get address list
  *@param userid number
  */
  getAllAddress(userId: number) {
    return this.http.get<APIResponse<GetAllAddressInteface[]>>(environment.baseUrl + AppConstant.GetAddressList + '?UserId=' + userId);
  }

  /** Function to get address
  *@param addressId number
  */
  getAddress(addressId: number) {
    return this.http.get<any>(environment.baseUrl + AppConstant.GetAddress + '?AddressId=' + addressId);
  }
  /** Function to get address list
  *@param userid number
  */
 deleteAddress(addressId: number, userId: number) {
  return this.http.get<any>(environment.baseUrl + AppConstant.DeleteAddress + '?AddressId=' + addressId + '&UserId=' + userId);
  }
 deletedUserQuestionare(userId: any, message: string) {
    return this.http.get(environment.baseUrl + AppConstant.DELETED_USER_QUESTIONARE + '?UserId=' + userId + '&Message=' + message);
  }
 
}
